import SalesTaxForm from './SalesTaxForm'
export default SalesTaxForm
